import { all } from 'redux-saga/effects';
import { watchSignup } from './signupSaga';
import watchAuth from './authSaga';
import watchProfile from './profileSaga';
import watchFetchNotifications from './notificationsSaga'
import watchUserData from './userdataSaga';
import watchFetchLocalities from './localitySaga';
import watchFetchLocalitiesRadius from './radiusSaga';


export default function* rootSaga() {
  yield all([
    watchSignup(),
    watchAuth(),
    watchProfile(),
    watchFetchNotifications(),
    watchUserData(),
    watchFetchLocalities(),
    watchFetchLocalitiesRadius(),
  ]);
}